// extracted by mini-css-extract-plugin
export default {"warnings":"warnings_warnings__1Z6Ei","warning":"warnings_warning__cPdjy","warning__icon":"warnings_warning__icon__2-8IA"};